var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillingEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.059 6.03782C16.2572 6.30207 16.367 6.64546 16.367 7.00035C16.367 7.3565 16.2572 7.69862 16.059 7.96287C14.8056 9.58536 11.9525 12.7448 8.62198 12.7448C5.29144 12.7448 2.4384 9.58536 1.18497 7.96287C0.983449 7.68852 0.874876 7.3492 0.876983 7.00035C0.876983 6.64546 0.986807 6.30207 1.18497 6.03782C2.4384 4.41533 5.29144 1.25586 8.62198 1.25586C11.9525 1.25586 14.8056 4.41533 16.059 6.03782Z",
    stroke: "#999999",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62186 9.55347C9.25506 9.55347 9.86232 9.28449 10.3101 8.80569C10.7578 8.32689 11.0093 7.6775 11.0093 7.00037C11.0093 6.32324 10.7578 5.67385 10.3101 5.19505C9.86232 4.71625 9.25506 4.44727 8.62186 4.44727C7.98866 4.44727 7.38139 4.71625 6.93365 5.19505C6.48591 5.67385 6.23438 6.32324 6.23438 7.00037C6.23438 7.6775 6.48591 8.32689 6.93365 8.80569C7.38139 9.28449 7.98866 9.55347 8.62186 9.55347Z",
    stroke: "#999999",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingEye);
export default __webpack_public_path__ + "static/media/billingEye.58de50628db3c055cae033fd1a62342e.svg";
export { ForwardRef as ReactComponent };